import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';

export function NotEnoughFundsDialog() {
    const {onClose} = RsnDialog.useControls();
    return (
        <RsnDialog.Window>
            <span className='whitespace-nowrap'>
                <RsnDialog.CenteredHeader
                    text='Oops! Not enough funds'
                    icon={{element: <RsnDialog.StatusIcon status={'attention'} />}}
                />
            </span>
            <RsnDialog.Body>You have insufficient funds in your account to complete the withdrawal.</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Secondary type='button' onClick={onClose}>
                    Got it
                </RsnButton.Secondary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
